import { useEffect, useState } from "react";

export function useLocalStorage<T>(defaultValue: T, key: string) {
    const [value, setValue] = useState<T>(getStoredValue());

    function getStoredValue() {
        const stored = localStorage.getItem(key);
        if (stored) {
            return JSON.parse(stored);
        } else {
            return defaultValue;
        }
    }

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [value]);

    return [value, setValue] as const;
}